const clearColorHexa = (color: string) => {
  if (color.includes('|')) {
    let arrayColorValue = ''
    if (color.split('|')[1].trim().includes('#')) {
      arrayColorValue = color.split('|')[1].trim()
    } else {
      arrayColorValue = color.split('|')[0].trim()
    }

    if (arrayColorValue.includes(',')) {
      arrayColorValue = arrayColorValue.split(',').map((hexa, index, array) => {
        const colorWidth = 100 / array.length
        return `${hexa} ${colorWidth * index}%, 
                ${hexa} ${colorWidth * ++index}%`
      }).join(',')
    }

    return arrayColorValue
  }
  if (color.includes('#')) {
    return color
  } else {
    return undefined
  }
}

const isMulticolor = (arrayColorValue: string) => {
  const hexa = clearColorHexa(arrayColorValue)
  if (hexa && hexa.includes(',')) {
    return true
  }
  return false
}

export { clearColorHexa, isMulticolor }
